/* eslint-disable jira/filename-case */
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
/**
 * Provides a natural sorting order for strings, factoring in locale-specific nuances such as numeric sorting and case sensitivity. This ensures that the sort order feels intuitive and familiar to users.
 */
export const alphabeticalSort = (a: string, b: string): number => {
	// @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
	if (a && b && a.localeCompare && b.localeCompare) {
		return a.localeCompare(b, 'en', {
			numeric: true,
			caseFirst: 'upper',
		});
	}
	const typeOfA = a === null ? 'null' : typeof a;
	const typeOfB = b === null ? 'null' : typeof b;
	const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
	log.safeErrorWithoutCustomerData(
		'software.board.filter',
		'localeCompare is not a function',
		error,
	);
	return 1;
};
